import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, DestroyRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { UnleashProxyService } from '@shared/services/unleash-proxy.service';

import { Menu } from '../../models/menu.model';
import { AuthService } from '../../services';
import { MenuUpdatedAction } from '../../store/actions/menu.action';
import { selectMenus } from '../../store/selectors/menu.selector';
import { AppStates } from '../../store/state/app.states';
import { SidebarService } from './sidebar.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  animations: [
    trigger('slide', [
      state('up', style({ height: 0 })),
      state('down', style({ height: '*' })),
      transition('up <=> down', animate(200))
    ])
  ]
})
export class SidebarComponent implements OnInit {
  menuGroup: MenuGroup[] = [];
  allMenus: Menu[] = [];
  activeIndex = 0;
  _allMenus: Menu[] = [];
  selectedSubMenu: Menu;
  currentPath: string;
  activeGroup = null;
  menuList = null;

  constructor(
    public sidebarService: SidebarService,
    private readonly store: Store<AppStates>,
    private router: Router,
    private authService: AuthService,
    private destroyRef: DestroyRef,
    private unleashProxyService: UnleashProxyService
  ) {
    // this.router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd) {
    //     let url = event.url;
    //     if (event.url.indexOf('/') > -1) {
    //       const urlPath = event.url.split('/');
    //       url = urlPath[urlPath.length - 1];
    //     }
    //     this.currentPath = url;
    //   }
    // });
  }

  ngOnInit() {
    this.menuGroup = [
      { group: 'HOME' },
      { group: 'STORE', title: 'Store Management' },
      { group: 'ADMIN', title: 'Back Office' },
      { group: 'DATA_INSIGHT', title: 'Data Insight' }
    ];
    this.store.select(selectMenus).subscribe(menus => {
      // Workaround for readonly issue
      this.allMenus = JSON.parse(JSON.stringify(menus));
      this._allMenus = structuredClone(this.allMenus);

      if (this.allMenus && this.allMenus.length > 0) {
        this.getMenuByGroup();
      }
    });

    this.unleashProxyService.updateTrigger$.subscribe(() => {
      this.allMenus = structuredClone(this._allMenus);
      this.getMenuByGroup();
      if (this.activeGroup) {
        this.menuList[this.activeGroup][this.activeIndex].active = true;
      }
    });
  }

  getMenuByGroup() {
    this.menuGroup.forEach(group => {
      const menus = this.allMenus
        .filter(m => m.group === group.group)
        .map(menu => {
          // If the menu has submenus, filter them by feature flag
          if (menu.submenus && Array.isArray(menu.submenus)) {
            menu.submenus = menu.submenus.filter(submenu => {
              return submenu.featureName ? this.unleashProxyService.isEnabled(submenu.featureName) : true;
            });
          }
          return menu;
        })
        // Optionally hide the entire menu if all submenus are filtered out
        .filter(menu => !menu.submenus || menu.submenus.length > 0);

      this.menuList = { ...this.menuList, [group.group]: menus };
    });
  }

  toggle(currentMenu) {
    if (!currentMenu.submenus) {
      this.authService.triggerWebVersion(`${currentMenu.link}`);
    }
    Object.keys(this.menuList).forEach(groupKey => {
      this.menuList[groupKey].forEach((element, index) => {
        if (element.title === currentMenu.title) {
          currentMenu.active = !currentMenu.active;
          this.activeIndex = index;
          this.activeGroup = currentMenu.group;
        } else {
          element.active = false;
        }
      });
    });
  }

  update(currentMenu) {
    if (window.innerWidth <= 768) {
      this.sidebarService.sidebarState = true;
    }

    this.store.dispatch(new MenuUpdatedAction(currentMenu));
  }

  getState(currentMenu) {
    if (currentMenu.active) {
      return 'down';
    } else {
      return 'up';
    }
  }
}

export class MenuGroup {
  title?: string;
  group: string;
}
